import { api } from '../config'

export const DASHBOARD_URL = {
  getDashboardInfo: (year: number) =>
    `${api.withAPI}/admin/dashboard/full/?year=${year}`,
  getYearInfo: (year: number) =>
    `${api.withAPI}/admin/dashboard/full/?year=${year}`,
  getActiveIosUsers: `${api.withAPI}/admin/analytics/activeUsers`,
  getActiveAndroidUsers: `${api.withAPI}/admin/analytics/activeUsers`,
  getActiveUsersSummary: `${api.withAPI}/admin/analytics/activeUsers/summary`,
  getOses: `${api.withAPI}/admin/analytics/oses`,
  getSessionCounts: `${api.withAPI}/admin/analytics/sessionCounts`,
  getModels: `${api.withAPI}/admin/analytics/models`,
  getSessionDuration: `${api.withAPI}/admin/analytics/sessionDuration`,
  getVersions: `${api.withAPI}/admin/analytics/versions`,
  getEvents: (eventName: string) =>
    `${api.withAPI}/admin/analytics/${eventName}/aggregated`,
  getUsersByMonth: `${api.withAPI}/admin/dashboard/usersByMonth`,
  getUsersByDate: `${api.withAPI}/admin/dashboard/usersByDate`,
  getPetsByMonth: `${api.withAPI}/admin/dashboard/petsByMonth`,
  getAllVersions: `${api.withAPI}/admin/analytics/versions/props`,
}
